import {Business} from "../../api/entities/Business";
import {INewOrderDetails} from "../../pages/newOrder/useNewOrderDetails";
import {EuiFormRow} from "@elastic/eui";
import ReactPDF, {PDFViewer} from "@react-pdf/renderer";
import {PurchaseSummary} from "../pdf/PurchaseSummary";
import React, {useEffect} from "react";

export interface IPurchaseLegalSignaturePdf {
    business: Business;
    orderDetails: INewOrderDetails;
    signatureUrl?: string;
    pdfKey: number;
    onDocumentChange?: (document: React.ReactElement<ReactPDF.DocumentProps, string | React.JSXElementConstructor<any>>) => void;
    onLegalTextChange?: (text: string) => void;
}

export const PurchaseLegalSignaturePdf: React.FC<IPurchaseLegalSignaturePdf> = (
    props,
) => {

    useEffect(() => {
        props.onDocumentChange?.(
            <PurchaseSummary
                business={props.business}
                order={props.orderDetails}
                signatureUrl={props.signatureUrl}
            />,
        );
    }, [props.orderDetails, props.signatureUrl, props.business]);

    return (
        <>
            <EuiFormRow fullWidth>
                <PDFViewer
                    key={props.pdfKey}
                    width="100%"
                    height="800"
                    showToolbar={true}
                >
                    <PurchaseSummary
                        business={props.business}
                        order={props.orderDetails}
                        signatureUrl={props.signatureUrl}
                        onTextChange={props.onLegalTextChange}
                    />
                </PDFViewer>
            </EuiFormRow>
        </>
    );
};
